<template>
  <div class="search-result">
    <section class="container nav-container">
      <Nav
        :list="navList"
        :activeValue.sync="activeValue"
        @on-success="searchHandler"
        class="channel_nav_container"
      ></Nav>
    </section>
    <section class="container" v-show="goodsList.length">
      <TablePage ref="list" @page-change="pageHandler" :total="total" :pageSizeNum="12">
        <div class="good-list-container act-ctn">
          <GoodsPanel
            class="activity-item"
            v-for="item in goodsList"
            :coverImage="item.coverImage"
            :price="item.salePrice"
            :oprice="item.oprice"
            :key="item.spuId"
            @handleTarget="handleTarget(item.id, item.activityType==0?2:1)"
          >
            <div class="desc-content" v-if="item.activityType == 1">
              <div class="content-left">
                <img class="content-icon" src="@/assets/img/ms-icon.png" alt="" />
                <span>秒杀中</span>
              </div>
              <count-down :startTime="item.startStamp" :endTime="item.endStamp" :secondsTxt="''"></count-down>
            </div>
            <div class="desc-content" v-else>
              <div class="content-left">
                <img class="content-icon" src="@/assets/img/group-icon.png" alt="" />
                <span>{{ item.groupSize }}人团</span>
              </div>
            </div>
          </GoodsPanel>
        </div>
      </TablePage>
    </section>
    <div class="empty-content" v-show="!goodsList.length">
      <el-empty></el-empty>
    </div>
  </div>
</template>

<script>
import Nav from "@/components/base/Nav.vue";
import GoodsPanel from "@/components/base/GoodsPanel";
import TablePage from "@/components/base/TablePage";
import SearchBar from "@/components/base/SearchBar";
import CountDown from "vue2-countdown";
import moment from "moment";
export default {
  name: "",
  components: { GoodsPanel, CountDown, TablePage, SearchBar, Nav },
  data() {
    return {
      navList: [
        {
          label: "进行中",
          labelEn: "In Progress",
          value: 1,
        },
        {
          label: "即将开始",
          labelEn: "Coming Soon",
          value: 0,
        },
      ],
      goodsList: [], //商品列表
      total: 0,
      activeValue: 1,
    };
  },
  props: {},
  computed: {},
  async mounted() {
    this.value = this.$route.query.value ?? "";
    this.searchHandler();
  },
  methods: {
    //初始化查询
    searchHandler() {
      this.$refs.list.reset();
    },
    //跳转
    handleTarget(id, type) {
      debugger
      this.$router.push(`/e-shop/good-info?activityId=${id}&type=${type}`);
    },
    //获取商品列表
    async pageHandler(page, pageSize) {
      const params = {
        page: page,
        pageSize: pageSize,
        statusList: [this.activeValue],
      };
      try {
        let {
          data: { list, total },
        } = await this.$api.getGoodsActivityList(params);
        this.goodsList = (list || []).map((item) => {
            item.endStamp = moment(item.endTime).valueOf();
            item.startStamp = moment(item.startTime).valueOf();
          return item;
        });
        this.total = total;
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    groupId(val) {
      this.searchHandler();
    },
  },
};
</script>

<style lang="scss" scoped>
.nav-container {
  margin-top: 60px;
  margin-bottom: 60px;
}
.e-shop-title {
  margin: 159px 0 99px;
}
.act-ctn {
  display: flex;
  flex-wrap: wrap;
}
.activity-item {
  margin-right: 30px;
  margin-bottom: 30px;
  width: 380px;
  &.activity-item:nth-child(3n) {
    margin-right: 0;
  }
  .desc-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .content-left {
      font-size: 16px;
      font-weight: 400;
      display: flex;
      align-items: center;
    }
    .content-icon {
      width: 21px;
      height: 21px;
      margin-right: 11px;
    }
  }
}
.channel-nav-container {
  margin-bottom: 60px;
  margin-top: 160px;
}
.good-list-container {
  display: flex;
  flex-wrap: wrap;
}
.total-result {
  font-size: 14px;
  color: #999999;
  margin-bottom: 30px;
}
.empty-content {
  min-height: 60vh;
}
</style>
